import React from "react";
import { Link } from "react-router-dom";
import { useSection } from "../../context/SiteContentContext";

const DEFAULT_SETTINGS = {
    contact_email: "info@skovomax.com",
    phones: ["+91 7799100060", "+91 7799100059"],
    corporate_address: "302 Model House, Punjagutta, Hyderabad - 500082, Telangana, India",
    factory_address: "Plot #UDL-1, Utterpally Village, Kandi Mandal, Sangareddy - 502295, Telangana, India",
};

export default function Footer() {
    const settings = useSection("settings", DEFAULT_SETTINGS);
    const year = new Date().getFullYear();
    return (
        <footer className="border-t border-white/10 bg-[#050510] pt-24 pb-10" data-testid="site-footer">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
                    <div className="md:col-span-5">
                        <h3 className="font-serif-display text-4xl md:text-5xl leading-[1.05] mb-4">
                            From Sensors <br />
                            <span className="italic text-white/70">to Systems Intelligence.</span>
                        </h3>
                        <p className="text-white/60 max-w-md leading-relaxed">
                            Skovomax builds photonic sensing platforms and GeoAI analytics for real-world
                            measurement, modeling, and decision systems.
                        </p>
                    </div>

                    <div className="md:col-span-2">
                        <div className="tech-label mb-5">Systems</div>
                        <ul className="space-y-3 text-sm text-white/70">
                            <li><Link className="tech-link" to="/technologies">Technologies</Link></li>
                            <li><Link className="tech-link" to="/platforms">Platforms</Link></li>
                            <li><Link className="tech-link" to="/applications">Applications</Link></li>
                            <li><Link className="tech-link" to="/case-studies">Case Studies</Link></li>
                        </ul>
                    </div>
                    <div className="md:col-span-2">
                        <div className="tech-label mb-5">Company</div>
                        <ul className="space-y-3 text-sm text-white/70">
                            <li><Link className="tech-link" to="/about">About</Link></li>
                            <li><Link className="tech-link" to="/services">Services</Link></li>
                            <li><Link className="tech-link" to="/insights">Insights</Link></li>
                            <li><Link className="tech-link" to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                    <div className="md:col-span-3">
                        <div className="tech-label mb-5">Contact</div>
                        <div className="font-body text-xs text-white/60 leading-relaxed space-y-3">
                            <div>
                                <div className="text-white/40 font-mono-tech tracking-[0.18em] uppercase text-[10px] mb-1">Corporate Office</div>
                                {settings.corporate_address}
                            </div>
                            <div>
                                <div className="text-white/40 font-mono-tech tracking-[0.18em] uppercase text-[10px] mb-1">Factory</div>
                                {settings.factory_address}
                            </div>
                            <div className="pt-2 space-y-1">
                                <div className="text-white">{settings.contact_email}</div>
                                {(settings.phones || []).map((p, i) => (
                                    <div key={i} className="text-white/80">{p}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-white/10 font-mono-tech text-[11px] tracking-[0.18em] uppercase text-white/40">
                    <div>© {year} Skovomax Engineering LLP. All rights reserved.</div>
                    <div className="flex gap-6">
                        <span>v0.26.0-alpha</span>
                        <span>Signal: Stable</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
